import React from 'react';



const Dashboard = () => {
    return (
        <div className='w-50 m-auto text-center mt-5'>
            <h1>Welcome Admin </h1>
        </div>
    );
};

export default Dashboard;